/**
 * Single source of truth for every piece of business information on the site.
 * Nothing else should hard-code a phone number, address, or brand string.
 */

export const business = {
  name: "Handyman Luxestuardo",
  legalName: "Handyman Luxestuardo",
  owner: "Estuardo Lux Muz",
  tagline: "Repair · Install · Improve",

  /** Business line. Used everywhere on the site. */
  phone: "(510) 600-9216",
  phoneHref: "tel:+15106009216",
  phoneDigits: "+15106009216",

  email: "luxestuardo@gmail.com",
  emailHref: "mailto:luxestuardo@gmail.com",

  address: {
    street: "686 Schafer Road",
    city: "Hayward",
    state: "California",
    stateShort: "CA",
    postalCode: "94544",
    country: "US",
    full: "686 Schafer Road, Hayward, CA 94544",
    lat: 37.6688,
    lng: -122.0808,
  },

  hours: {
    label: "Monday – Saturday",
    time: "7:00 AM – 7:00 PM",
    closed: "Sunday: Closed",
    /** schema.org openingHours format */
    schema: ["Mo-Sa 07:00-19:00"],
  },

  domain: "handymanluxestuardo.com",
  siteUrl: "https://handymanluxestuardo.com",

  yelp: "Handyman Luxestuardo",
  yelpUrl: "https://www.yelp.com/biz/handyman-luxestuardo-hayward",

  /** Service radius used in copy and on the coverage map. */
  serviceRadiusMiles: 30,
  serviceRadiusMeters: 48280,

  offers: {
    returning: {
      title: "Returning Customer Discount",
      short: "10% off your next project",
      detail:
        "Already had us out? Mention it when you book and take 10% off your next job — no coupon, no expiry.",
    },
    referral: {
      title: "Referral Bonus",
      short: "$50 when a referral books",
      detail:
        "Send a neighbor, friend, or family member our way and you'll get $50 back once their project is complete.",
    },
    headline: "10% off returning customers · $50 referral bonus",
  },

  logo: "/logo.png",
  ogImage: "/og-image.png",
} as const;

/** Formatted address line helpers. */
export const addressLine1 = business.address.street;
export const addressLine2 = `${business.address.city}, ${business.address.stateShort} ${business.address.postalCode}`;
